<!-- 商户管理/门店列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column sortable label="编号" align="center" prop="id" width="80">
    </el-table-column>
    <el-table-column
      label="门店名称"
      prop="number"
      align="center"
    ></el-table-column>
    <el-table-column label="商户" prop="name" align="center"></el-table-column>
    <el-table-column label="门店信息" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">联系电话：{{ scope.row.rzTime }}</div>
        <div class="table_scope_line">详细信息：{{ scope.row.dqTime }}</div>
      </template>
    </el-table-column>
    <!-- <el-table-column
      label="营业时间"
      prop="name"
      align="center"
    ></el-table-column>
    <el-table-column
      label="是否停业"
      prop="name"
      align="center"
    ></el-table-column> -->
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="editShopDetail(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text">删除</el-button>
          <el-button type="text">二维码</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    editShopDetail(id) {
      console.log(id);
    }
  }
};
</script>
